import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useMemo,
  useLayoutEffect,
} from "react";
import {
  Col,
  Collapse,
  Container,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import Lottie from "lottie-react";
import Logo from "../assets/images/icon/mr-logo.svg";
import NotificationIcon from "../assets/images/icon/notification.webp";
import MessageIcon from "../assets/images/icon/message.webp";
import HomeIcon from "../assets/images/icon/home.png";
import HomeActive from "../assets/images/icon/home-active.webp";
import ClinicalActive from "../assets/images/icon/clinical-active.png";
import ClinicalIcon from "../assets/images/icon/clinical.png";
import MentorshipIcon from "../assets/images/icon/mentorship.svg";
import MentorshipActive from "../assets/images/icon/mentorship-active.svg";
import EventsIcon from "../assets/images/icon/calendar.png";
import EventActive from "../assets/images/icon/calendar-active.png";
import CourseIcon from "../assets/images/icon/course.png";
import CourseActive from "../assets/images/icon/course-active.png";
import SubIcon from "../assets/images/Sub.svg"
import {
  AGENDA,
  ADDPOST,
  CHAT,
  CLINICAL_SESSIONS,
  COURSES,
  MENTORSHIP,
  EVENTS,
  FEED,
  JOBS,
  LIVE_WEBINARS,
  LOGIN,
  NOTIFICATIONS,
  PROFILE,
  SEARCH,
  SETTINGMODULE,
  WALLET,
  DOCTOR_ACCOUNT,
  FACILITY_ACCOUNT,
  INDUSTRY_ACCOUNT,
  NEW_PROFILE_DOCTOR,
  NEW_PROFILE_FACILITY,
  NEW_PROFILE_INDUSTRY,
} from "../constants/RoutesUrl";
import { Link, useNavigate } from "react-router-dom";

import AnimatedImage from "../assets/images/live_webinar_lottie_file.json";
import WalletIcon from "../assets/images/icon/wallet.png";
import SettingsIcon from "../assets/images/icon/settings.png";
import FilesIcon from "../assets/images/icon/files.png";
import HelpIcon from "../assets/images/icon/headphones.png";
import LogoutIcon from "../assets/images/icon/logout.png";
import { LogoutApi } from "../constants/API";
import ModalSubscription from "./modals/ModalSubscription";
import axios from "axios";
import { toast } from "react-toastify";
import CustomTooltip from "./common/CustomTooltip";
import ImageComponent from "./common/ImageComponent";
import ProfileAvatar from "./common/ProfileAvatar";
import { FeedDataRefetch, FeedType, Language, LoginUserData } from "../App";
import { MdLanguage } from "react-icons/md";
import { IoIosArrowForward } from "react-icons/io";
import { CountContext } from "../constants/ProtectedRoute";
import { getSplashData, syncMentorApprovalFlag } from "../services/api";
import PlusPng from "../assets/images/icons/plus.png";
import SearchInput from "./search/SearchInput";
import { useQuery, useQueryClient } from "react-query";
import { useMixpanelTracking } from "../hooks/useMixpanelTracking";
import { MixpanelEvents } from "../constants/MixpanelEvents";
import { FaDollarSign } from "react-icons/fa";
import { HiHome } from "react-icons/hi";
import { LuCalendarDays, LuCalendarCheck, LuGraduationCap, LuVideo, LuStethoscope, LuLogOut } from "react-icons/lu";
import SplashLogo from "../assets/images/splashLoader.png";
import { preloadImages } from "../utils/imageCache";
import "./NavBar.css";

// Preload critical navbar assets immediately so they are cached in session memory
preloadImages([
  SplashLogo,
  Logo,
  NotificationIcon,
  MessageIcon,
  PlusPng,
  HomeIcon,
  HomeActive,
  ClinicalActive,
  ClinicalIcon,
  MentorshipIcon,
  MentorshipActive,
  EventsIcon,
  EventActive,
  CourseIcon,
  CourseActive,
]);

const NavBar = ({ setShowPost, wrapperClassName = "" }) => {
  const { updateCount } = useContext(CountContext) || {};
  const { splashData, updateSplash } = useContext(LoginUserData);
  const { updateFeedType } = useContext(FeedType);
  const { isHomeRefreshing, refreshHomeFeed } = useContext(FeedDataRefetch) || {};
  const { lang, updateLang } = useContext(Language);
  const Navigate = useNavigate();
  const signupDataRaw = localStorage.getItem("SignupData");
  const { data } = signupDataRaw ? JSON.parse(signupDataRaw) : {};
  const [langModalOpen, setLangModalOpen] = useState(false);
  const selectedLanguage = localStorage.getItem('selectedLanguage') || 'English';
  const queryClient = useQueryClient();
  const { track } = useMixpanelTracking();

  const cachedSplash = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("SplashData") || "{}");
    } catch {
      return {};
    }
  }, []);

  const currentUserId =
    splashData?.user?.id ||
    cachedSplash?.user?.id ||
    data?.id ||
    data?.user?.id ||
    data?.data?.id ||
    null;

  const currentUserType =
    data?.user_type ||
    splashData?.user?.user_type ||
    cachedSplash?.user?.user_type ||
    "doctor";

  const currentUserName =
    splashData?.user?.name ||
    cachedSplash?.user?.name ||
    data?.name ||
    [data?.firstname, data?.lastname].filter(Boolean).join(" ") ||
    "User";

  const currentUsername =
    splashData?.user?.user_name ||
    cachedSplash?.user?.user_name ||
    data?.user_name ||
    "";

  const userProfileIdentifier = currentUsername || currentUserId;

  const userProfileLink = currentUserId
    ? currentUserType === "doctor"
      ? `${NEW_PROFILE_DOCTOR}/${userProfileIdentifier}`
      : currentUserType === "facility"
        ? `${NEW_PROFILE_FACILITY}/${userProfileIdentifier}`
        : currentUserType === "industry"
          ? `${NEW_PROFILE_INDUSTRY}/${userProfileIdentifier}`
          : `${PROFILE}/${userProfileIdentifier}`
    : "#";

  const [walletCount, setWalletCount] = useState(() => {
    const amt = cachedSplash?.home?.counts?.withdraw_amount;
    return amt != null ? Number(amt).toFixed(2) : "0.00";
  });
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [state, setState] = useState({
    isLoading: false,
    ModalStatus: false,
    counts: cachedSplash?.home?.counts || {},
    naveOpen: false,
    profileModal: false,
    profileDropdown: false,
    closingProfile: false,
    typeDropdown: false,
    closingFilter: false,
  });
  const storedSplashImage = cachedSplash?.user?.image;
  const profileAvatarSrc = useMemo(() => {
    return (
      splashData?.user?.image ||
      storedSplashImage ||
      state.counts?.user?.image ||
      JSON.parse(localStorage.getItem("SignupData") || "{}")?.data?.image ||
      JSON.parse(localStorage.getItem("SignupData") || "{}")?.data?.user_image ||
      ""
    );
  }, [splashData?.user?.image, storedSplashImage, state.counts?.user?.image]);

  const [showCreatePost, setShowCreatePost] = useState(false);
  const [recentSearches, setRecentSearches] = useState(() => {
    const list = cachedSplash?.home?.recent_searches || [];
    return Array.isArray(list) ? [...new Set(list.filter((item) => item && item !== "undefined" && item.trim?.() !== ""))] : [];
  });
  const [topSearches, setTopSearches] = useState(() => {
    const list = cachedSplash?.home?.top_searches || [];
    return Array.isArray(list) ? [...new Set(list)] : [];
  });

  const constantPagesData = useMemo(
    () => [
      {
        id: "hometab",
        image: HomeIcon,
        image_active: HomeActive,
        active: true,
        tooltip: lang?.home,
        link: FEED,
        width: 23,
        height: 26,
        find: "",
        // Icon-to-label gap (px) — kept per-tab instead of one shared
        // Bootstrap gap-2 class, since each icon's own visual weight/padding
        // makes the same numeric gap look tighter or looser than its
        // neighbors; tune independently here instead of a single global value.
        gap: 6,
      },
      {
        id: "agendatab",
        image: EventsIcon,
        image_active: EventActive,
        active: false,
        tooltip: lang?.agenda || "Agenda",
        link: AGENDA,
        width: 23,
        height: 26,
        find: "agenda",
        gap: 8,
      },
      // {
      //   id: "eventtab",
      //   image: EventsIcon,
      //   image_active: EventActive,
      //   active: false,
      //   tooltip: lang?.events,
      //   link: EVENTS + "/1",
      //   width: 23,
      //   height: 26,
      //   find: "event",
      //   gap: 8,
      // },
      {
        id: "coursetab",
        image: CourseIcon,
        image_active: CourseActive,
        active: false,
        tooltip: lang?.courses,
        link: COURSES,
        width: 21,
        height: 24,
        find: "course",
        gap: 4,
      },
      // {
      //   id: "clinicaltab",
      //   image: ClinicalIcon,
      //   image_active: ClinicalActive,
      //   active: false,
      //   tooltip: "Webinar",
      //   link: CLINICAL_SESSIONS,
      //   width: 24,
      //   height: 24,
      //   find: "clinical",
      //   gap: 8,
      // },
      data?.user_type === "doctor" && {
        id: "mentorshiptab",
        image: MentorshipIcon,
        image_active: MentorshipActive,
        active: false,
        tooltip: lang?.mentorship || "Mentorship",
        link: MENTORSHIP,
        width: 26,
        height: 24,
        find: "mentorship",
        gap: 8,
      },
    ].filter(Boolean),
    [lang, data?.user_type],
  );
  const constantData = useMemo(
    () =>
      [
        {
          id: "1",
          image: PlusPng,
          toolTip: lang.create_post_sm,
          link: ADDPOST + "/1",
          isCreatePost: true,
        },
        { id: "2", image: MessageIcon, toolTip: lang?.messages, link: CHAT },
        {
          id: "3",
          image: NotificationIcon,
          toolTip: lang?.notifications,
          link: NOTIFICATIONS,
        },
      ].filter(Boolean),
    [lang],
  );

  const handleStateUpdate = (updates) => {
    setState((prevState) => ({ ...prevState, ...updates }));
  };
  const toggleDropdown = () => {
    setState((prevState) => ({
      ...prevState,
      profileDropdown: !state.profileDropdown,
      closingProfile: !state.closingProfile,
    }));
  };

  const handleDropdown = (e, ref, setStateKey) => {
    if (ref.current && !ref.current.contains(e.target)) {
      handleStateUpdate({ [setStateKey]: true });
      setTimeout(() => handleStateUpdate({ [setStateKey]: false }), 300);
    }
  };

  const handleSubmit = () => {
    handleStateUpdate({ isLoading: true });
    axios
      .post(
        LogoutApi,
        {
          deviceId: "MedicalRadar Website Device",
        },
        {
          headers: {
            Authorization: `Bearer ${data.token}`, // Set the Authorization header
          },
        },
      )
      .then((response) => {
        if (response.data.status) {
          // Clear sessionStorage completely
          sessionStorage.clear();

          // Preserve credentials and static data in localStorage
          const preservedKeys = ['rememberedEmail', 'rememberedPassword', 'countriesData', 'selectedLanguage', 'mr_doctor_has_logged_in'];
          const currentItems = { ...localStorage };
          Object.keys(currentItems).forEach(key => {
            if (!preservedKeys.includes(key)) {
              localStorage.removeItem(key);
            }
          });

          queryClient.clear();
          handleStateUpdate({ ModalStatus: false, isLoading: false });
          updateFeedType("all");

          Navigate(LOGIN);
        } else {
          handleStateUpdate({ isLoading: false });
          toast.error(response.data.error);
        }
      })

      .catch((error) => {
        console.log(error);
      });
  };

  const handleCount = (counts, user) => {
    updateCount({ counts: { ...counts, user: { ...user } } });
    handleStateUpdate({ counts: { ...counts, user: { ...user } } });
  };

  useQuery({
    queryKey: ["splashData"],
    queryFn: getSplashData,
    staleTime: 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data.data.status) {
        updateSplash(data.data);
        localStorage.setItem("SplashData", JSON.stringify(data.data));
        syncMentorApprovalFlag(data.data.user);
        handleCount(data.data.home.counts, data.data.user);
        const uniqueRecentSearches = [
          ...new Set(
            data.data.home.recent_searches.filter(
              (item) =>
                item &&
                item !== "undefined" &&
                item !== null &&
                item.trim() !== "",
            ),
          ),
        ];
        setRecentSearches(uniqueRecentSearches);

        const uniqueTopSearches = [...new Set(data.data.home.top_searches)];

        setTopSearches(uniqueTopSearches);
        let withdraw_amount =
          data?.data?.home?.counts?.withdraw_amount?.toFixed(2);
        setWalletCount(withdraw_amount);
      } else {
        toast.error("Error while fetching splash data");
      }
    },
  });

  const collapseProfileDropdown = useRef(null);

  useEffect(() => {
    const handleProfileDropdown = (e) => {
      handleDropdown(e, collapseProfileDropdown, "closingProfile");
    };

    if (!state.profileDropdown)
      document.addEventListener("mousedown", handleProfileDropdown);

    return () => {
      document.removeEventListener("mousedown", handleProfileDropdown);
    };
  }, [state.profileDropdown]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        collapseProfileDropdown.current &&
        !collapseProfileDropdown.current.contains(e.target)
      ) {
        handleStateUpdate({ profileDropdown: false });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useLayoutEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        if (window.location.pathname === "/feed") {
          const postFormElem = document.getElementById("mr-post-form-anchor");
          let shouldShow = false;
          if (postFormElem) {
            const rect = postFormElem.getBoundingClientRect();
            shouldShow = rect.bottom <= 70;
          } else {
            shouldShow = window.scrollY > 160;
          }
          setShowCreatePost((prev) => (prev !== shouldShow ? shouldShow : prev));
        } else {
          setShowCreatePost((prev) => (prev ? false : prev));
        }
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* Top Shield: Sits at z-index 10, below dark hero covers (z-index 20) and above scrolled page elements (z-index 1) */}
      <div className={`mr-island-top-shield ${wrapperClassName}`.trim()} />
      {/* FLOATING ISLAND NAVIGATION BAR */}
      <div className={`mr-island-nav-wrapper ${wrapperClassName}`.trim()}>
        <div className="mr-island-nav">
          {/* Left section: Logo */}
          <div className="mr-island-left">
            <div className="mr-island-logo">
              <img
                src={SplashLogo}
                alt="Medical Radar"
                className="mr-full-logo"
                onClick={() => {
                  if (window.location.pathname === FEED || window.location.pathname === "/feed") {
                    sessionStorage.removeItem("prevFeedData");
                    refreshHomeFeed?.();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  } else {
                    Navigate(FEED);
                  }
                }}
              />
              <img
                src={Logo}
                alt="Medical Radar"
                className="mr-mobile-logo-icon"
                onClick={() => {
                  if (window.location.pathname === FEED || window.location.pathname === "/feed") {
                    sessionStorage.removeItem("prevFeedData");
                    refreshHomeFeed?.();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  } else {
                    Navigate(FEED);
                  }
                }}
              />
            </div>
          </div>

          {/* Center section: Navigation Tabs (Strict Absolute Centering) */}
          <div className="d-none d-xl-flex align-items-center mr-island-tabs">
            {constantPagesData.map((data) => (
              <PagesTabsComponent
                key={data.id}
                id={data.id}
                counts={state.counts}
                image={
                  data.link === window.location.pathname ||
                    window.location.pathname.search(data.find) > 0
                    ? data.image_active
                    : data.image
                }
                status={
                  data.link === window.location.pathname ||
                  window.location.pathname.search(data.find) > 0
                }
                toolTip={data.tooltip}
                link={data.link}
                height={data.height}
                width={data.width}
                showLabel
                gap={data.gap}
              />
            ))}
          </div>

          {/* Right section: Search + Action Buttons + Profile Avatar (Desktop) */}
          <div className="d-none d-xl-flex align-items-center position-relative mr-island-right">
            <SearchInput
              recentSearches={recentSearches}
              setRecentSearches={setRecentSearches}
              topSearches={topSearches}
            />

            {state.counts?.active_webinar ? (
              <CustomTooltip
                text={lang.live_webinars}
                compClassName="w_fit_content"
                account_class="mt-3"
              >
                <div
                  className="cursor"
                  onClick={() => {
                    Navigate(LIVE_WEBINARS);
                  }}
                  style={{ width: "36px", height: "36px" }}
                >
                  <Lottie
                    animationData={AnimatedImage}
                    loop
                    autoplay
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
              </CustomTooltip>
            ) : null}

            {constantData.map((value) => (
              <IconsComponent
                image={value.image}
                toolTip={value.toolTip}
                key={value.id}
                link={value?.link}
                updateState={(newValue) => {
                  handleStateUpdate({ typeDropdown: newValue });
                }}
                counts={state.counts}
                setShowPost={setShowPost}
                isVisible={value.isCreatePost ? showCreatePost : true}
              />
            ))}

            <CustomTooltip
              text={lang?.account}
              compClassName="w_fit_content"
              topMargin="0.8rem"
              account_class="m--7px"
            >
              <ProfileAvatar
                src={profileAvatarSrc}
                size={38}
                variant="gradient"
                isOnline={true}
                onClick={toggleDropdown}
                alt="Account"
                className="cursor-pointer"
              />
            </CustomTooltip>

            {/* Desktop Profile Dropdown */}
            <Collapse
              isOpen={state.profileDropdown && !state.closingProfile}
              innerRef={collapseProfileDropdown}
              className="position-absolute end-0 top-0"
              style={{ zIndex: "99", marginTop: "56px" }}
            >
              <div className="mr-profile-dropdown-card">
                {/* ── User Profile Header ── */}
                <Link
                  to={userProfileLink}
                  className="mr-dropdown-profile-header"
                  onClick={() => handleStateUpdate({ profileDropdown: false })}
                >
                  <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1 }}>
                    <div className="mr-dropdown-avatar-wrap">
                      <ProfileAvatar
                        src={profileAvatarSrc}
                        size={42}
                        variant="plain"
                        alt={currentUserName}
                      />
                    </div>
                    <div className="mr-dropdown-user-info">
                      <span className="mr-dropdown-user-name">
                        {currentUserName}
                      </span>
                      {currentUsername && (
                        <span className="mr-dropdown-username">
                          @{currentUsername.replace(/^@/, "")}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="mr-dropdown-header-arrow">
                    <IoIosArrowForward size={15} />
                  </div>
                </Link>

                <div className="mr-dropdown-menu-divider" />

                {/* ── Wallet ── */}
                <Link
                  to={WALLET}
                  className="mr-dropdown-menu-item"
                  onClick={() => {
                    track(MixpanelEvents.viewWallet);
                    handleStateUpdate({
                      profileDropdown: false,
                    });
                  }}
                >
                  <div className="mr-dropdown-item-left">
                    <div className="mr-dropdown-item-icon-box">
                      <img src={WalletIcon} alt="Wallet" />
                    </div>
                    <span className="mr-dropdown-item-label">
                      {lang?.wallet}: <span style={{ color: "#00BADA", fontWeight: 700 }}>{walletCount}€</span>
                    </span>
                  </div>
                  <IoIosArrowForward className="mr-dropdown-item-chevron" />
                </Link>

                {/* ── My Subscription (Industry only) ── */}
                {data?.user_type === 'industry' && (
                  <div
                    className="mr-dropdown-menu-item"
                    onClick={() => {
                      handleStateUpdate({ profileDropdown: false });
                      setShowSubscriptionModal(true);
                      track(MixpanelEvents.VIEW_CURRENT_SUBSCRIPTION);
                    }}
                  >
                    <div className="mr-dropdown-item-left">
                      <div className="mr-dropdown-item-icon-box">
                        <img src={SubIcon} alt="Subscription" />
                      </div>
                      <span className="mr-dropdown-item-label">
                        {lang?.my_subscription || "My Subscription"}
                      </span>
                    </div>
                    <IoIosArrowForward className="mr-dropdown-item-chevron" />
                  </div>
                )}

                {/* ── Manage Account ── */}
                <div
                  className="mr-dropdown-menu-item"
                  onClick={() => {
                    const userType = data?.user_type;
                    if (userType === 'facility') Navigate(FACILITY_ACCOUNT);
                    else if (userType === 'industry') Navigate(INDUSTRY_ACCOUNT);
                    else Navigate(DOCTOR_ACCOUNT);
                    handleStateUpdate({ profileDropdown: false });
                  }}
                >
                  <div className="mr-dropdown-item-left">
                    <div className="mr-dropdown-item-icon-box">
                      <img src={SettingsIcon} alt="Manage Account" />
                    </div>
                    <span className="mr-dropdown-item-label">
                      {lang?.manage_account_nav || lang?.manage_account}
                    </span>
                  </div>
                  <IoIosArrowForward className="mr-dropdown-item-chevron" />
                </div>

                {/* ── Terms & Privacy ── */}
                <Link
                  to={SETTINGMODULE + "/6"}
                  className="mr-dropdown-menu-item"
                  onClick={() => {
                    track(MixpanelEvents.viewPrivacyPolicy);
                    handleStateUpdate({
                      profileDropdown: false,
                    });
                  }}
                >
                  <div className="mr-dropdown-item-left">
                    <div className="mr-dropdown-item-icon-box">
                      <img src={FilesIcon} alt="Terms & Privacy" />
                    </div>
                    <span className="mr-dropdown-item-label">
                      {lang?.terms_privacy}
                    </span>
                  </div>
                  <IoIosArrowForward className="mr-dropdown-item-chevron" />
                </Link>

                {/* ── Language ── */}
                <div
                  className="mr-dropdown-menu-item"
                  onClick={() => {
                    handleStateUpdate({ profileDropdown: false });
                    setLangModalOpen(true);
                  }}
                >
                  <div className="mr-dropdown-item-left">
                    <div className="mr-dropdown-item-icon-box">
                      <MdLanguage size={18} />
                    </div>
                    <span className="mr-dropdown-item-label">
                      {lang?.new_language || 'Language'}
                    </span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="mr-dropdown-tag">
                      {selectedLanguage || "EN"}
                    </span>
                    <IoIosArrowForward className="mr-dropdown-item-chevron" />
                  </div>
                </div>

                {/* ── Help ── */}
                <Link
                  to={SETTINGMODULE + "/5"}
                  className="mr-dropdown-menu-item"
                  onClick={() => {
                    handleStateUpdate({ profileDropdown: false });
                  }}
                >
                  <div className="mr-dropdown-item-left">
                    <div className="mr-dropdown-item-icon-box">
                      <img src={HelpIcon} alt="Help" />
                    </div>
                    <span className="mr-dropdown-item-label">
                      {lang?.help}
                    </span>
                  </div>
                  <IoIosArrowForward className="mr-dropdown-item-chevron" />
                </Link>

                <div className="mr-dropdown-menu-divider" />

                {/* ── Sign Out (Destructive Item) ── */}
                <div
                  className="mr-dropdown-signout-item"
                  onClick={() => {
                    track(MixpanelEvents.signOut);
                    handleStateUpdate({
                      profileDropdown: false,
                      ModalStatus: true,
                    });
                  }}
                >
                  <div className="mr-dropdown-signout-icon-box">
                    <img src={LogoutIcon} alt="Sign Out" />
                  </div>
                  <span className="mr-dropdown-item-label">
                    {lang?.sign_out}
                  </span>
                </div>
              </div>
            </Collapse>
          </div>

          {/* Mobile/Tablet Right Action Icons */}
          <div className="d-flex d-xl-none align-items-center gap-2">
            {state.counts?.active_webinar ? (
              <div
                className="cursor"
                onClick={() => {
                  Navigate(LIVE_WEBINARS);
                }}
                style={{ width: "34px", height: "34px" }}
              >
                <Lottie
                  animationData={AnimatedImage}
                  loop
                  autoplay
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            ) : null}

            <SearchInput
              recentSearches={recentSearches}
              setRecentSearches={setRecentSearches}
              topSearches={topSearches}
            />

            {constantData.map((value) => (
              <IconsComponent
                image={value.image}
                toolTip={value.toolTip}
                key={value.id}
                link={value?.link}
                updateState={(newValue) => {
                  handleStateUpdate({ typeDropdown: newValue });
                }}
                counts={state.counts}
                setShowPost={setShowPost}
                isVisible={value.isCreatePost ? showCreatePost : true}
              />
            ))}

            <ProfileAvatar
              src={profileAvatarSrc}
              size={34}
              variant="gradient"
              isOnline={true}
              onClick={() => handleStateUpdate({ profileModal: true })}
              alt="Account"
              className="cursor-pointer"
            />
          </div>
        </div>
        {isHomeRefreshing && (
          <div className="mr-home-refresh-indicator" role="status" aria-label="Refreshing home feed">
            <Spinner size="sm" />
          </div>
        )}
      </div>

      {/* Mobile/Tablet Profile Modal */}
      <Modal
        centered
        isOpen={state.profileModal}
        toggle={() =>
          handleStateUpdate({
            profileModal: !state.profileModal,
          })
        }
        data-bs-keyboard="false"
        backdrop={true}
        className="d-xl-none mr-profile-mobile-modal"
      >
        <ModalBody className="p-2">
          <div className="mr-profile-dropdown-card w-100" style={{ maxWidth: "100%", boxShadow: "none", border: "none" }}>
            {/* ── User Profile Header ── */}
            <Link
              to={userProfileLink}
              className="mr-dropdown-profile-header"
              onClick={() => handleStateUpdate({ profileModal: false })}
            >
              <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1 }}>
                <div className="mr-dropdown-avatar-wrap">
                  <ProfileAvatar
                    src={profileAvatarSrc}
                    size={42}
                    variant="plain"
                    alt={currentUserName}
                  />
                </div>
                <div className="mr-dropdown-user-info">
                  <span className="mr-dropdown-user-name">
                    {currentUserName}
                  </span>
                  {currentUsername && (
                    <span className="mr-dropdown-username">
                      @{currentUsername.replace(/^@/, "")}
                    </span>
                  )}
                </div>
              </div>
              <div className="mr-dropdown-header-arrow">
                <IoIosArrowForward size={15} />
              </div>
            </Link>

            <div className="mr-dropdown-menu-divider" />

            {/* ── Wallet ── */}
            <Link
              to={WALLET}
              className="mr-dropdown-menu-item"
              onClick={() => {
                track(MixpanelEvents.viewWallet);
                handleStateUpdate({ profileModal: false });
              }}
            >
              <div className="mr-dropdown-item-left">
                <div className="mr-dropdown-item-icon-box">
                  <img src={WalletIcon} alt="Wallet" />
                </div>
                <span className="mr-dropdown-item-label">
                  {lang?.wallet}: <span style={{ color: "#00BADA", fontWeight: 700 }}>{walletCount}€</span>
                </span>
              </div>
              <IoIosArrowForward className="mr-dropdown-item-chevron" />
            </Link>

            {/* ── My Subscription (Industry only) ── */}
            {data?.user_type === 'industry' && (
              <div
                className="mr-dropdown-menu-item"
                onClick={() => {
                  handleStateUpdate({ profileModal: false });
                  setShowSubscriptionModal(true);
                  track(MixpanelEvents.VIEW_CURRENT_SUBSCRIPTION);
                }}
              >
                <div className="mr-dropdown-item-left">
                  <div className="mr-dropdown-item-icon-box">
                    <img src={SubIcon} alt="Subscription" />
                  </div>
                  <span className="mr-dropdown-item-label">
                    {lang?.my_subscription || "My Subscription"}
                  </span>
                </div>
                <IoIosArrowForward className="mr-dropdown-item-chevron" />
              </div>
            )}

            {/* ── Manage Account ── */}
            <div
              className="mr-dropdown-menu-item"
              onClick={() => {
                const userType = data?.user_type;
                if (userType === 'facility') Navigate(FACILITY_ACCOUNT);
                else if (userType === 'industry') Navigate(INDUSTRY_ACCOUNT);
                else Navigate(DOCTOR_ACCOUNT);
                handleStateUpdate({ profileModal: false });
              }}
            >
              <div className="mr-dropdown-item-left">
                <div className="mr-dropdown-item-icon-box">
                  <img src={SettingsIcon} alt="Manage Account" />
                </div>
                <span className="mr-dropdown-item-label">
                  {lang?.manage_account_nav || lang?.manage_account}
                </span>
              </div>
              <IoIosArrowForward className="mr-dropdown-item-chevron" />
            </div>

            {/* ── Terms & Privacy ── */}
            <Link
              to={SETTINGMODULE + "/6"}
              className="mr-dropdown-menu-item"
              onClick={() => {
                track(MixpanelEvents.viewPrivacyPolicy);
                handleStateUpdate({ profileModal: false });
              }}
            >
              <div className="mr-dropdown-item-left">
                <div className="mr-dropdown-item-icon-box">
                  <img src={FilesIcon} alt="Terms & Privacy" />
                </div>
                <span className="mr-dropdown-item-label">
                  {lang?.terms_privacy}
                </span>
              </div>
              <IoIosArrowForward className="mr-dropdown-item-chevron" />
            </Link>

            {/* ── Language ── */}
            <div
              className="mr-dropdown-menu-item"
              onClick={() => {
                handleStateUpdate({ profileModal: false });
                setLangModalOpen(true);
              }}
            >
              <div className="mr-dropdown-item-left">
                <div className="mr-dropdown-item-icon-box">
                  <MdLanguage size={18} />
                </div>
                <span className="mr-dropdown-item-label">
                  {lang?.new_language || 'Language'}
                </span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <span className="mr-dropdown-tag">
                  {selectedLanguage || "EN"}
                </span>
                <IoIosArrowForward className="mr-dropdown-item-chevron" />
              </div>
            </div>

            {/* ── Help ── */}
            <Link
              to={SETTINGMODULE + "/5"}
              className="mr-dropdown-menu-item"
              onClick={() => {
                handleStateUpdate({ profileModal: false });
              }}
            >
              <div className="mr-dropdown-item-left">
                <div className="mr-dropdown-item-icon-box">
                  <img src={HelpIcon} alt="Help" />
                </div>
                <span className="mr-dropdown-item-label">
                  {lang?.help}
                </span>
              </div>
              <IoIosArrowForward className="mr-dropdown-item-chevron" />
            </Link>

            <div className="mr-dropdown-menu-divider" />

            {/* ── Sign Out (Destructive Item) ── */}
            <div
              className="mr-dropdown-signout-item"
              onClick={() => {
                track(MixpanelEvents.signOut);
                handleStateUpdate({
                  profileDropdown: false,
                  profileModal: false,
                  ModalStatus: true,
                });
              }}
            >
              <div className="mr-dropdown-signout-icon-box">
                <img src={LogoutIcon} alt="Sign Out" />
              </div>
              <span className="mr-dropdown-item-label">
                {lang?.sign_out}
              </span>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* MOBILE FLOATING BOTTOM NAVIGATION ISLAND */}
      <div className="d-xl-none mr-mobile-bottom-nav">
        {constantPagesData.map((data) => (
          <PagesTabsComponent
            key={data.id}
            id={data.id}
            counts={state.counts}
            image={
              data.link === window.location.pathname ||
                window.location.pathname.search(data.find) > 0
                ? data.image_active
                : data.image
            }
            status={
              data.link === window.location.pathname ||
              window.location.pathname.search(data.find) > 0
            }
            toolTip={data.tooltip}
            link={data.link}
            height={data.height}
            width={data.width}
            isMobile
          />
        ))}
      </div>

      <ModalSubscription
        isOpen={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
      />

      <Modal
        isOpen={langModalOpen}
        toggle={() => setLangModalOpen(false)}
        centered
        zIndex={9999}
      >
        <ModalBody className="bg-white rounded p-4">
          <h5 className="roboto-bold fs-16 mb-3">{lang?.new_language || 'Language'}</h5>
          {['English', 'Spanish'].map((l) => (
            <div
              key={l}
              className="d-flex justify-content-between align-items-center px-3 py-2 rounded cursor manue-hover mb-2"
              style={{
                border: selectedLanguage === l ? '1.5px solid #1DC1DD' : '1.5px solid #e5e7eb',
                background: selectedLanguage === l ? '#edfafd' : 'transparent',
                cursor: 'pointer',
              }}
              onClick={() => { updateLang(l); setLangModalOpen(false); }}
            >
              <span className="fs-14 roboto-medium" style={{ color: selectedLanguage === l ? '#1DC1DD' : '#374151' }}>
                {l === 'English' ? (lang?.new_english || 'English') : (lang?.new_spanish || 'Spanish')}
              </span>
              {selectedLanguage === l && (
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <circle cx="9" cy="9" r="9" fill="#1DC1DD" />
                  <path d="M5 9.5L7.5 12L13 6.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </div>
          ))}
        </ModalBody>
      </Modal>

      <Modal
        isOpen={state.ModalStatus}
        toggle={
          !state.isLoading
            ? () => handleStateUpdate({ ModalStatus: !state.ModalStatus })
            : undefined
        }
        centered
        dialogClassName="mr-signout-modal-dialog"
        contentClassName="mr-signout-modal-content"
        zIndex={9999}
        backdrop={state.isLoading ? "static" : true}
      >
        <div className="mr-signout-card">
          {/* Icon Badge */}
          <div className="mr-signout-badge-outer">
            <div className="mr-signout-badge-inner">
              <LuLogOut size={36} strokeWidth={2} />
            </div>
          </div>

          {/* Header Text */}
          <div className="mr-signout-header">
            <h2 className="mr-signout-title">
              {lang?.do_want_sign_out_account}
            </h2>
            <p className="mr-signout-subtitle">{lang?.signout_modal_para}</p>
          </div>

          {/* Actions */}
          <div className="mr-signout-actions-row">
            <button
              type="button"
              className="mr-signout-cancel-btn"
              onClick={() => handleStateUpdate({ ModalStatus: false })}

            >
              {lang?.cancel}
            </button>

            <button
              type="button"
              className="mr-signout-confirm-btn"
              onClick={() => {
                handleSubmit();
              }}
              disabled={state.isLoading}
            >
              {state.isLoading ? (
                <Spinner size="sm" color="light" />
              ) : (
                lang?.yes_signout
              )}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default React.memo(NavBar);

const TAB_ICONS = {
  hometab: HiHome,
  agendatab: LuCalendarCheck,
  eventtab: LuCalendarDays,
  coursetab: LuGraduationCap,
  clinicaltab: LuVideo,
  mentorshiptab: LuStethoscope,
};

const PagesTabsComponent = React.memo(({
  id,
  status,
  toolTip,
  link,
  counts,
  showLabel,
  gap = 8,
  isMobile = false,
}) => {
  const Navigate = useNavigate();
  const { updateRefetch, refetch, refreshHomeFeed } = useContext(FeedDataRefetch);
  const TabIcon = TAB_ICONS[id];

  const handleClick = () => {
    if (link === window.location.pathname) {
      if (id === "hometab") {
        sessionStorage.removeItem("prevFeedData");
        refreshHomeFeed?.();
      } else if (id === "agendatab") {
        sessionStorage.removeItem("agendaPageData");
      } else if (id === "eventtab") {
        sessionStorage.removeItem("eventsPageData");
      } else if (id === "coursetab") {
        sessionStorage.removeItem("coursesPageData");
      } else if (id === "jobstab") {
        sessionStorage.removeItem("prevJobsData");
      } else if (id === "clinicaltab") {
        sessionStorage.removeItem("prevClinicalSessionsData");
        sessionStorage.removeItem("prevStartedClinicalSessionsData");
      }
      if (id !== "hometab") {
        updateRefetch(!refetch);
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      Navigate(link);
    }
  };

  if (isMobile) {
    return (
      <div
        className={`mr-mobile-tab ${status ? "mr-mobile-tab--active" : ""}`}
        onClick={handleClick}
      >
        <div className="position-relative d-flex align-items-center justify-content-center">
          {TabIcon && <TabIcon className="mr-mobile-tab-icon" />}
          {id === "clinicaltab" && counts && counts.active_clinical_session > 0 ? (
            <div className="mr-island-badge">
              <span>{counts.active_clinical_session}</span>
            </div>
          ) : null}
        </div>
        <span className="mr-mobile-tab-label">{toolTip}</span>
      </div>
    );
  }

  return (
    <div
      className={`mr-island-tab ${status ? "mr-island-tab--active" : ""}`}
      style={{ gap: `${gap}px` }}
      onClick={handleClick}
    >
      <div className="mr-island-tab-icon position-relative">
        {TabIcon && <TabIcon />}
        {id === "clinicaltab" && counts && counts.active_clinical_session > 0 ? (
          <div className="mr-island-badge">
            <span>{counts.active_clinical_session}</span>
          </div>
        ) : null}
      </div>
      {showLabel && (
        <span className="mr-island-tab-label">
          {toolTip}
        </span>
      )}
    </div>
  );
});

const IconsComponent = React.memo(({
  image,
  toolTip,
  link,
  updateState,
  counts,
  setShowPost,
  isVisible = true,
}) => {
  const Navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const { lang } = useContext(Language);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isCreatePost = toolTip === lang?.create_post_sm;

  if (isCreatePost && window.location.pathname !== "/feed") {
    return null;
  }

  if (isCreatePost) {
    return (
      <div
        className={`mr-island-create-btn-wrapper ${isVisible ? "mr-island-create-btn--visible" : ""
          }`}
      >
        <CustomTooltip text={toolTip}>
          <div
            className="mr-island-action-btn mr-island-action-btn--create"
            onClick={() => setShowPost(true)}
          >
            <img
              src={image}
              alt="Action icon"
              className="mr-island-action-icon"
              style={{ width: "14px", height: "14px" }}
            />
          </div>
        </CustomTooltip>
      </div>
    );
  }

  const unreadCount =
    toolTip === lang?.messages
      ? counts?.unread || 0
      : toolTip === lang?.notifications
        ? (counts?.clinical || 0) +
        (counts?.clinical_session || 0) +
        (counts?.event || 0) +
        (counts?.course || 0) +
        (counts?.social || 0) +
        (counts?.webinar || 0)
        : 0;

  const isNotification = toolTip === lang?.notifications;
  const isMessages = toolTip === lang?.messages;

  return (
    <CustomTooltip text={toolTip}>
      <div
        className={`mr-island-action-btn ${isCreatePost
          ? "mr-island-action-btn--create"
          : isNotification
            ? "mr-island-action-btn--bell"
            : isMessages
              ? "mr-island-action-btn--msg"
              : ""
          }`}
        onClick={() => {
          if (link === null) {
            if (screenWidth < 992) {
              setFilterModal(true);
            } else {
              updateState(!open);
            }
          } else {
            if (isCreatePost) {
              setShowPost(true);
            } else {
              Navigate(link);
            }
          }
        }}
      >
        {unreadCount > 0 && (
          <div className="mr-island-count-badge">
            <span>{unreadCount}</span>
          </div>
        )}
        <img
          src={image}
          alt="Action icon"
          className="mr-island-action-icon"
          style={{
            width: isCreatePost ? "14px" : toolTip === lang?.notifications ? "17px" : "18px",
            height: isCreatePost ? "14px" : toolTip === lang?.notifications ? "19px" : "16px",
          }}
        />
      </div>
    </CustomTooltip>
  );
});

IconsComponent.args = {
  autohide: true,
  flip: true,
};

IconsComponent.argTypes = {
  placement: {
    control: { type: "select" },
    options: ["bottom"],
  },
};

PagesTabsComponent.args = {
  autohide: true,
  flip: true,
};

PagesTabsComponent.argTypes = {
  placement: {
    control: { type: "select" },
    options: ["bottom"],
  },
};


